import { PropsWithChildren } from "react";

type CardProps = PropsWithChildren<{
  title?: string;
  actions?: React.ReactNode;
  action?: React.ReactNode;
  subtitle?: string;
}>;

function Card({ title, subtitle, actions, action, children }: CardProps) {
  const renderedActions = actions || action;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
      {(title || renderedActions || subtitle) && (
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            {title && <h3 className="text-base font-semibold text-slate-800">{title}</h3>}
            {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
          </div>
          {renderedActions}
        </div>
      )}
      <div className="text-sm text-slate-700">{children}</div>
    </div>
  );
}

export default Card;
